<template>
  <span class="icon">
    <svg class="icon__svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="setIcon"></use></svg>
  </span>
</template>

<script>

export default {
  
  computed: {

    setIcon() {

      return '#icon-' + this.icon;

    }

  },

  props : [

    // Default props
    'icon',

  ],   

}

</script>

<style lang="scss">

  .icon {

    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {

      stroke-width: 2px;

      fill: #fff;
      stroke: #fff;

      width: 100%;
      height: 100%;

    }

  }

</style>



// WEBPACK FOOTER //
// Icon.vue?45fa467f